<template>
  <div v-if="isLogin">
    <!-- 聊天窗口 -->
    <transition name="chat-scale">
      <div v-show="$store.state.dislog.chat" ref="chatWindow" class="chat-window" :style="winStyle">
        <div class="chat-header" @mousedown.prevent="onWinMouseDown" @touchstart.prevent="onWinTouchStart">
          <span class="header-title">
            <a-icon type="customer-service" /> 在线沟通
          </span>
          <span class="header-actions">
            <a-icon type="minus" class="action-icon" @click.stop="minimize" />
            <!-- <a-icon type="close" class="action-icon" @click.stop="closeChat" /> -->
          </span>
        </div>
        <div class="chat-body">
          <div class="chat-sidebar">
            <div v-for="group in sessionList" :key="group.id" class="session-group">
              <!-- 分组 -->
              <div class="group-header" @click="toggleGroup(group.id)">
                <a-icon :type="expandedGroups[group.id] ? 'caret-down' : 'caret-right'" class="group-arrow" />
                <span class="group-name">{{ group.title }}</span>
                <a-badge v-if="group.unread_count && group.unread_count > 0" status="error" />
              </div>
              <transition name="slide-down">
                <!-- 成员 -->
                <div v-show="expandedGroups[group.id]" class="group-children">
                  <div v-for="session in group.children" :key="session.id" class="session-item"
                    :class="{ active: currentSessionId === session.id }"
                    @click.stop="switchSession(session, session.id, group.id)">
                    <a-badge class="session-badge" v-if="session.unread_count" :count="session.unread_count"
                      size="small" />
                    <a-avatar :icon="session.audit == 0 ? 'exclamation-circle' : session.avatar ? null : 'user'"
                      :size="34"
                      :style="{ background: session.audit == 0 ? '#f85b5040' : session.status == 'offline' ? '#a3a3a3  ' : '#2d6fc4' }" />
                    <div class="session-info">
                      <div class="session-name">
                        <div
                          :class="['session-uname', session.audit == 0 ? 'disablename' : session.status == 'offline' ? 'greyuname' : '']">
                          {{ session.uname }}</div>
                        <div
                          :class="['session-status', session.audit == 0 ? 'disable' : session.status == 'offline' ? 'grey' : '']">
                          {{ session.audit == 0 ? '已禁用' : session.status == 'online' ? '在线' : '离线' }}</div>
                      </div>
                      <div class="session-preview">{{ session.last_message_content }}</div>
                    </div>
                    <span class="session-time">{{ session.last_message_at_desc }}</span>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div class="chat-main">
            <a-spin class="spin" v-if="isloading" />
            <div class="current-card" v-if="currentSessionId">
              <a-avatar :icon="isDisabled ? 'exclamation-circle' : 'user'" :size="32"
                :style="{ background: isDisabled ? '#f85b5040' : currentstatus == 'offline' ? '#a3a3a3  ' : '#2d6fc4' }" />
              <span :class="['name', isDisabled ? 'disablename' : currentstatus == 'offline' ? 'greyuname' : '']">{{
                currentName }}</span>
              <span :class="['session-status', isDisabled ? 'disable' : currentstatus == 'offline' ? 'grey' : '']">{{
                isDisabled ? '已禁用' : currentstatus == 'online' ? '在线' : '离线' }}</span>
            </div>
            <div v-if="warnStatus" class="warning-tip">
              <a-spin>
                <a-icon slot="indicator" type="loading" style="font-size: 24px;color: #fc382a;" spin />
              </a-spin>
              当前网络异常，请稍后再试
            </div>
            <div ref="msgList" class="message-list" @scroll="handleMessageScroll" v-if="currentSessionId">
              <div v-for="(msg, idx) in currentMessages" :key="idx" class="msg-row"
                :class="{ self: currentUserId == msg.sender.id }">
                <a-avatar icon="user" :size="32"
                  :style="{ background: currentUserId == msg.sender.id ? '#3ace52' : isDisabled ? '#f85b5040' : currentstatus == 'offline' ? '#a3a3a3' : '#2d6fc4' }" />
                <div :class="['msg-bubble', currentUserId == msg.sender.id ? 'msg-bubble-my' : '']">
                  <div class="msg-uname"
                    :style="{ 'color': currentUserId == msg.sender.id ? '#333333' : isDisabled ? '#f85b5040' : currentstatus == 'offline' ? '#a3a3a3' : '' }">
                    {{ msg.sender.uname }}</div>
                  <!-- 文本 -->
                  <div v-if="msg.message_type === 'text'"
                    :class="['msg-content', currentUserId == msg.sender.id ? 'my' : '']">{{ msg.content }}</div>
                  <!-- 图片 -->
                  <div
                    v-if="(msg.message_type === 'document' || msg.message_type === 'image') && Filetype(msg.content) == 3"
                    class="msg-image">
                    <img :src="getOssUrl(msg.content)" @click="previewImage(msg.content)" @load="handleImageLoad" />
                  </div>
                  <!-- 文件 -->
                  <div v-if="msg.message_type === 'file'"
                    :class="['msg-file', currentUserId == msg.sender.id ? 'my' : '']" @click="downloadFile(msg)">
                    <img class="file-type-icon" :src="getFileIcon(msg.file.file_name)" alt="文件图标">
                    <div class="file-info">
                      <div class="file-name" :style="{ 'color': currentUserId == msg.sender.id ? '#fff' : '#333' }">{{
                        formatFileShowName(msg.file.file_name,135) }}</div>
                      <div class="file-size">{{ msg.fileSize }}</div>
                    </div>
                  </div>

                  <!-- 邀请文件 -->
                  <div v-if="msg.message_type === 'document' && Filetype(msg.content) != 3">
                    <div v-if="msg.file && msg.file.file_ext && officeExtList.includes(msg.file.file_ext.toLowerCase())"
                      class="msg-document" @click="downloadFile(msg)">
                      <div class="document_title txt">{{ msg.sender.id == currentUserId ? '您发起了一份在线文档共享' :
                        '邀请与您一起修改文件' }}</div>
                      <div class="document_imag" :style="{ background: getFileStyle(msg).bgColor }">
                        <img class="document-pic" :src="getFileStyle(msg).iconSrc" alt="">
                      </div>
                      <div class="document_title"> {{ formatFileShowName(msg.file.file_name,170) }} </div>
                    </div>

                    <div v-else :class="['msg-file', currentUserId == msg.sender.id ? 'my' : '']"
                      @click="downloadFile(msg)">
                      <img class="file-type-icon" :src="getFileIcon(msg.file.file_name)" alt="文件图标">
                      <div class="file-info">
                        <div class="file-name" :style="{ 'color': currentUserId == msg.sender.id ? '#fff' : '#333' }">{{
                          formatFileShowName(msg.file.file_name,135) }}</div>
                        <div class="file-size">{{ msg.fileSize }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="msg-time">{{ msg.send_at }}</div>
                </div>
              </div>
            </div>

            <!-- 待发送图片预览 -->
            <div v-if="pendingImages.length" class="pending-images">
              <div v-for="(img, idx) in pendingImages" :key="img.id" class="pending-img-item">
                <img :src="img.previewUrl" />
                <a-icon type="close-circle" class="remove-pending-img" @click="removePendingImage(idx)" />
              </div>
            </div>

            <div class="chat-input-area" v-if="currentSessionId">
              <a-textarea v-model="inputText" :rows="3" :disabled="isDisabled" :maxLength="maxLength"
                placeholder="请输入消息" @keydown="handleKeydown" @paste="handlePaste" />
            </div>

            <div class="chat-toolbar" v-if="!isDisabled && currentSessionId">
              <div class="toolbar">
                <a-upload name="image" accept="image/*" :show-upload-list="false" :custom-request="handleImageUpload">
                  <a-icon type="picture" class="tool-btn" title="发送图片" />
                </a-upload>
                <a-upload name="file" :show-upload-list="false" :custom-request="handleFileUpload"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,.rar,.mp4,.m4a,.mp3,.7z,.ppt,.pptx,.wps">
                  <a-icon type="paper-clip" class="tool-btn" title="发送文件" />
                </a-upload>
                <a-icon type="reload" class="tool-btn" @click="loadHistory" title="刷新" />
                <a-icon type="delete" class="tool-btn" @click="clearText" title="清空内容" />
              </div>
              <div :class="['send-btn', inputText.trim() ? 'send-ok' : '']" @click="sendText">发送</div>
            </div>

          </div>
        </div>

        <div class="resize-handle" title="拖动调整大小" @mousedown.stop="onResizeStart" @touchstart.stop="onResizeStart">
          <div class="resize-lines">
            <div class="r-line"></div>
            <div class="r-line"></div>
            <div class="r-line"></div>
          </div>
        </div>
      </div>
    </transition>
    <FileSee ref="FileSee" :info="info"></FileSee>
  </div>
</template>

<script>
function useDrag(elRef, options = {}) {
  const { onMove, onEnd, onStart } = options
  let startX = 0, startY = 0, startLeft = 0, startTop = 0, moved = false
  const getEl = () => {
    if (!elRef) return null
    return elRef.value !== undefined ? elRef.value : elRef
  }
  const handleStart = (clientX, clientY) => {
    const el = getEl()
    if (!el) return false
    const rect = el.getBoundingClientRect()
    startX = clientX; startY = clientY
    startLeft = rect.left; startTop = rect.top
    moved = false
    onStart && onStart()
    return true
  }
  const handleMove = (clientX, clientY) => {
    const dx = clientX - startX, dy = clientY - startY
    if (Math.abs(dx) > 2 || Math.abs(dy) > 2) moved = true
    onMove && onMove({ left: startLeft + dx, top: startTop + dy, dx, dy, moved })
  }
  return {
    mouseDown: (e) => {
      if (!handleStart(e.clientX, e.clientY)) return
      const onMouseMove = (ev) => handleMove(ev.clientX, ev.clientY)
      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
        onEnd && onEnd({ moved })
      }
      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },
    touchStart: (e) => {
      const touch = e.touches[0]
      if (!handleStart(touch.clientX, touch.clientY)) return
      const onTouchMove = (ev) => { const t = ev.touches[0]; handleMove(t.clientX, t.clientY) }
      const onTouchEnd = () => {
        document.removeEventListener('touchmove', onTouchMove)
        document.removeEventListener('touchend', onTouchEnd)
        onEnd && onEnd({ moved })
      }
      document.addEventListener('touchmove', onTouchMove)
      document.addEventListener('touchend', onTouchEnd)
    }
  }
}
import $http from "superagent"
import { Tacitly } from '@/assets/js/Tacitly'
import FileSee from '@/components/filesee'
import { getFileIcon, Filetype, formatFileShowName } from '../../assets/js/fileIcon'
import { onlineUrlToken } from '@/server/api'
export default {
  name: 'FloatingChat',
  components: {
    FileSee,
  },
  props: {
    isLogin: { type: Boolean, default: true },
    wsUrl: { type: String, default: '' },
    userId: { type: [String, Number, null], default: null }
  },
  data() {
    let user = {}
    try { user = JSON.parse(localStorage.getItem('user') || '{}') } catch (e) { }

    return {
      token: localStorage.getItem('t') || '',
      wstoken: '',
      currentUser: user,
      currentUserId: user.id || '',
      info: {},
      btnPos: { left: null, top: null, right: 40, bottom: 150 },
      isDraggingBtn: false,
      btnDragMoved: false,
      chatVisible: false,
      winPos: { left: null, top: null, right: 100, bottom: 100 },
      winSize: { width: 820, height: 620 },
      isDraggingWin: false,
      ws: null,
      wsConnected: false,
      // ===== 心跳相关 =====
      heartTimer: null,        // 心跳发送定时器
      heartTimeoutTimer: null, // 心跳超时检测定时器
      heartInterval: 10000,    // 心跳间隔 10 秒
      heartTimeout: 10000,     // 超时时间 10 秒
      reconnectTimer: null,    // 重连定时器
      reconnectDelay: 3000,    // 断线后 3 秒重连
      isManualClose: false,
      // ===== 分组会话 =====
      expandedGroups: {},
      currentSessionId: null,
      currentGroupId: 1,
      currentName: null,
      currentstatus: null,
      isDisabled: false,
      sessionList: [],
      messages: {},
      inputText: '',
      maxLength: 2000,
      totalUnread: 0,
      nowSessionkey: null,
      page: 1,
      page_size: 10,
      currentMessages: [],
      current_account: null,
      isloading: false,
      loadingMore: false,
      hasMoreData: true,
      messageTotal: 0,
      isFirstPage: true,
      verify_connection: true,
      resizeHandler: null,
      dragInited: false, // 拖拽初始化完成标记
      btnSize: { width: 0, height: 0 }, // 缓存悬浮按钮尺寸
      realWinSize: { width: 0, height: 0 }, // 聊天窗口dom尺寸缓存
      warnStatus: false,
      pendingImages: [],
      officeExtList: [
        "doc", "docx", "docm", "dotx",
        "xls", "xlsx", "xlsm", "xltx", "xltm", "xlsb", "xlam",
        "ppt", "pptx", "pptm", "ppsx", "ppsm"
      ]
    }
  },
  computed: {
    realWsUrl() {
      if (this.wsUrl) return this.wsUrl
      if (process.env.NODE_ENV === 'development') {
        // 切换调试环境只改这里的域名即可
        const targetDomain = 'haoyun.hfajglxt.com' // 浩韵线下
        // const targetDomain = 'testold.hfajglxt.com' // 萧银线下
        return `wss://${targetDomain}/socket`
      }
      try {
        let fullUrl = Tacitly.Base_Port
        if (fullUrl.startsWith('/')) {
          fullUrl = window.location.origin + fullUrl
        }
        const u = new URL(fullUrl)
        const proto = u.protocol === 'https:' ? 'wss:' : 'ws:'
        let _url = `${proto}//${u.host}/socket`
        return _url
      } catch (err) {
        console.log('解析ws地址失败', err)
        return
      }
    },
    btnStyle() {
      const s = {}
      if (this.btnPos.left !== null) s.left = this.btnPos.left + 'px'
      else s.right = this.btnPos.right + 'px'
      if (this.btnPos.top !== null) s.top = this.btnPos.top + 'px'
      else s.bottom = this.btnPos.bottom + 'px'
      return s
    },
    winStyle() {
      const s = {}
      if (this.winPos.left !== null) s.left = this.winPos.left + 'px'
      else s.right = this.winPos.right + 'px'
      if (this.winPos.top !== null) s.top = this.winPos.top + 'px'
      else s.bottom = this.winPos.bottom + 'px'
      s.width = this.winSize.width + 'px'
      s.height = this.winSize.height + 'px'
      return s
    },
    imgList() {
      if (!this.currentMessages) return []
      const result = this.currentMessages
        .filter(ele => ele.message_type === 'image' || ele.message_type === 'document')
        .map((ele, index) => ({
          url: ele.content,
          index
        }))

      return result
    }
  },
  watch: {
    userId(newId) {
      if (!newId) return;
      // 有用户id，并且ws未连接，则发起连接
      if (!this.wsConnected && !this.ws) {
        // 重新读取token、用户信息
        let user = {}
        try { user = JSON.parse(localStorage.getItem('user') || '{}') } catch (e) { }
        this.token = localStorage.getItem('t') || ''
        this.currentUser = user
        this.currentUserId = user.id || ''
      }
    }
  },
  mounted() {
    if (!this.token || !this.currentUserId) {
      console.warn('[FloatingChat] 未登录，不加载')
      return
    }
    this.haveToken()
    // 等待dom渲染完毕，读取一次真实尺寸，存入缓存
    this.$nextTick(() => {
      const btnEl = this.$refs.floatBtn
      const winEl = this.$refs.chatWindow
      if (btnEl) {
        this.btnSize.width = btnEl.offsetWidth
        this.btnSize.height = btnEl.offsetHeight
      }
      if (winEl) {
        this.realWinSize.width = winEl.offsetWidth
        this.realWinSize.height = winEl.offsetHeight
      }
      this.dragInited = true // 标记初始化完成，resize才执行位置修正
    })

    this._btnDrag = useDrag(this.$refs.floatBtn, {
      onStart: () => { this.isDraggingBtn = true; this.btnDragMoved = false },
      onMove: ({ left, top, moved }) => {
        this.btnDragMoved = moved
        const sw = window.innerWidth
        const sh = window.innerHeight
        // 直接读取缓存，不再读DOM
        const btnW = this.btnSize.width
        const btnH = this.btnSize.height
        if (btnW === 0 || btnH === 0) return

        let l = Math.max(0, Math.min(left, sw - btnW))
        let t = Math.max(0, Math.min(top, sh - btnH))
        this.btnPos = { left: l, top: t, right: null, bottom: null }
      },
      onEnd: () => { this.isDraggingBtn = false }
    })

    this._winDrag = useDrag(this.$refs.chatWindow, {
      onStart: () => { this.isDraggingWin = true },
      onMove: ({ left, top }) => {
        const sw = window.innerWidth
        const sh = window.innerHeight
        // 优先业务状态winSize（窗口resize缩放）， fallback缓存dom尺寸
        const winW = this.winSize.width || this.realWinSize.width
        const winH = this.winSize.height || this.realWinSize.height
        if (winW === 0 || winH === 0) return

        let l = Math.max(0, Math.min(left, sw - winW))
        let t = Math.max(0, Math.min(top, sh - winH))
        this.winPos = { left: l, top: t, right: null, bottom: null }
      },
      onEnd: () => { this.isDraggingWin = false }
    })
  },
  beforeDestroy() {
    this.destroyWs()
    const chatMain = this.$refs.chatWindow
    if (chatMain) {
      chatMain.removeEventListener('paste', this.handlePaste)
    }
  },
  methods: {
    getFileIcon, Filetype,
    /* ---------- 悬浮按钮 ---------- */
    onBtnMouseDown(e) { this._btnDrag && this._btnDrag.mouseDown(e) },
    onBtnTouchStart(e) { this._btnDrag && this._btnDrag.touchStart(e) },

    getFileStyle(msg) {
      if (!msg || !msg.file) {
        return {
          bgColor: '#d6e5f880',
          iconSrc: ''
        }
      }
      const ext = msg.file.file_ext ? msg.file.file_ext.toLowerCase() : ''
      if (['ppt', 'pptx', 'pptm', 'ppsx', 'ppsm'].includes(ext)) {
        return {
          bgColor: '#f8e5d680',
          iconSrc: 'https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/document-ppt.png'
        }
      }
      if (['xls', 'xlsx', 'xlsm', 'xltx', 'xltm', 'xlsb', 'xlam'].includes(ext)) {
        return {
          bgColor: '#d6f8e780',
          iconSrc: 'https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/document-xlsx.png'
        }
      }
      if (['doc', 'docx', 'docm', 'dotx'].includes(ext)) {
        return {
          bgColor: '#d6e5f880',
          iconSrc: 'https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/document-docx.png'
        }
      }
      return {
        bgColor: '#d6e5f880',
        iconSrc: 'https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/document-docx.png'
      }
    },
    /* ---------- 窗口拖拽 ---------- */
    onWinMouseDown(e) { this._winDrag && this._winDrag.mouseDown(e) },
    onWinTouchStart(e) { this._winDrag && this._winDrag.touchStart(e) },

    /* ---------- 窗口缩放 ---------- */
    onResizeStart(e) {
      const isTouch = e.type === 'touchstart'
      const startX = isTouch ? e.touches[0].clientX : e.clientX
      const startY = isTouch ? e.touches[0].clientY : e.clientY
      const startW = this.winSize.width
      const startH = this.winSize.height

      document.body.style.userSelect = 'none'
      document.body.style.overflow = 'hidden'

      const onMove = (ev) => {
        const cx = isTouch ? ev.touches[0].clientX : ev.clientX
        const cy = isTouch ? ev.touches[0].clientY : ev.clientY
        const w = Math.max(400, Math.min(1200, startW + (cx - startX)))
        const h = Math.max(320, Math.min(900, startH + (cy - startY)))
        this.winSize = { width: w, height: h }
      }

      const onEnd = () => {
        if (isTouch) {
          window.removeEventListener('touchmove', onMove)
          window.removeEventListener('touchend', onEnd)
        } else {
          window.removeEventListener('mousemove', onMove)
          window.removeEventListener('mouseup', onEnd)
        }
        document.body.style.userSelect = ''
        document.body.style.overflow = ''
        const winEl = this.$refs.chatWindow
        if (winEl) {
          this.realWinSize.width = winEl.offsetWidth
          this.realWinSize.height = winEl.offsetHeight
        }
      }

      if (isTouch) {
        window.addEventListener('touchmove', onMove, { passive: false })
        window.addEventListener('touchend', onEnd)
      } else {
        window.addEventListener('mousemove', onMove)
        window.addEventListener('mouseup', onEnd)
      }
    },

    /* ---------- 窗口控制 ---------- */
    minimize() {
      this.$store.dispatch('openkey', { key: 'chat', by: false })
      this.toggleGroup(this.currentGroupId)
      this.currentMessages = []
      // this.chatVisible = false
      this.nowSessionkey = null
      this.currentSessionId = null
      this.page = 1
      this.loadingMore = false
      this.hasMoreData = true
      this.currentName = null
      this.currentstatus = null
      this.isDisabled = false
      this.currentGroupId = null
    },

    /* -----------请求连接的token-------- */
    async haveToken() {
      const { havetoken } = await import("@/server/chat")
      const res = await havetoken({ t: this.token })
      if (res.t) {
        this.wstoken = res.t
        this.connectWs()
      }
    },
    /* -------- WebSocket + 心跳 -------- */
    connectWs() {
      // if(!this.token) return
      if (this.ws)
        if (!this.realWsUrl) return
      try {
        this.ws = new WebSocket(this.realWsUrl)
        this.ws.onopen = () => {
          // console.log('[WS] 连接成功')
          this.wsConnected = true
          this.verify_connection = true
          // 启动心跳
          this.startHeartBeat()
          // 身份认证
          this.ws.send(JSON.stringify({
            event: 'auth',
            data: { t: this.wstoken, user_id: this.currentUserId }
          }))
        }
        this.ws.onmessage = (e) => {
          // if(JSON.parse(e.data).event != 'heart.pong'){
          //   console.log('消息回执',JSON.parse(e.data));
          // }
          // 收到任何消息都重置心跳超时
          this.resetHeartTimeout()
          try {
            const data = JSON.parse(e.data)
            if (data.event == 'auth.success') {
              this.getSessionList()
            }
            if (data.event === 'heart.pong' || data.event === 'heart.ping') {
              // console.log('[WS] 心跳响应')
              return
            }
            if (data.code === 401) {
              this.verify_connection = false
              this.haveToken()
              return
            }
            if (data.code === 400 || data.code === 500) {
              this.warnStatus = true
              return
            }
            this.handleReceive(e.data)
          } catch (err) {
            this.handleReceive(e.data)
          }
        }
        this.ws.onerror = (err) => {
          // console.error('[WS] 连接错误', err)
          this.wsConnected = false
        }
        this.ws.onclose = (event) => {
          // console.log('[WS] 连接断开',event)
          this.wsConnected = false
          this.ws = null
          this.stopHeartBeat()
          // 如果是手动关闭，禁止重连
          if (this.isManualClose) {
            this.isManualClose = false
            return
          }
          // 自动重连
          this.reconnectTimer = setTimeout(() => {
            console.log('连接断开，正在尝试重连...')
            // this.$message.info('连接断开，正在尝试重连...')
            this.connectWs()
          }, this.reconnectDelay)
        }
      } catch (err) {
        console.error('[WS] 连接失败', err)
      }
    },
    /* ---------- 心跳机制 ---------- */
    startHeartBeat() {
      this.stopHeartBeat()
      this.heartTimer = setInterval(() => {
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify({ event: 'heart.ping', data: { t: this.wstoken } }))
          // console.log('[WS] 发送心跳')
          // 发送后启动超时检测，10 秒内没收到任何消息就判定断线
          this.heartTimeoutTimer = setTimeout(() => {
            // console.log('[WS] 心跳超时，强制重连')
            if (this.ws) {
              this.ws.close()
              this.ws = null
            }
          }, this.heartTimeout)
        }
      }, this.heartInterval)
    },

    stopHeartBeat() {
      if (this.heartTimer) {
        clearInterval(this.heartTimer)
        this.heartTimer = null
      }
      this.resetHeartTimeout()
    },

    resetHeartTimeout() {
      if (this.heartTimeoutTimer) {
        clearTimeout(this.heartTimeoutTimer)
        this.heartTimeoutTimer = null
      }
    },
    /* -------- 获取账户列表 -------- */
    async getSessionList() {
      const { sessions } = await import("@/server/chat")
      const res = await sessions()
      this.sessionList = res.list
      this.calcTotalUnread()
    },
    destroyWs() {
      this.isManualClose = true
      this.stopHeartBeat()
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer)
        this.reconnectTimer = null
      } 3
      if (this.ws) {
        this.ws.close()
        this.ws = null
      }
    },
    /* ---------- 分组展开/收起 ---------- */
    toggleGroup(groupId) {
      this.$set(this.expandedGroups, groupId, !this.expandedGroups[groupId])
    },
    triggerExpandFirstGroup() {
      let count = 0
      const poll = () => {
        if (this.sessionList && this.sessionList.length > 0) {
          this.expandFirstGroup()
          this.currentMessages = []
          this.nowSessionkey = null
          this.currentSessionId = null
          this.page = 1
          this.loadingMore = false
          this.hasMoreData = true
          this.currentName = null
          this.currentstatus = null
          this.isDisabled = false
          return
        }
        count++
        if (count < 20) {
          setTimeout(poll, 100)
        } else {
          console.warn('等待sessionList超时，无法执行展开第一个分组')
        }
      }
      poll()
    },
    // 默认展开第一个分组
    expandFirstGroup() {
      if (!this.sessionList || this.sessionList.length === 0) return

      this.sessionList.forEach(group => {
        this.$set(this.expandedGroups, group.id, false)
      })

      // 展开第一个分组
      const firstGroup = this.sessionList[0]
      this.$set(this.expandedGroups, firstGroup.id, true)
    },
    /* ---------- 切换会话 ---------- */
    async switchSession(sessionData, sessionId, groupId) {
      if (this.currentSessionId == sessionId) return
      this.isloading = true
      try {
        const { get_session } = await import("@/server/chat")
        this.currentMessages = []
        this.nowSessionkey = null
        this.page = 1
        this.loadingMore = false
        this.hasMoreData = true
        if (sessionData.session_key) {
          this.nowSessionkey = sessionData.session_key
        } else {
          const res = await get_session({ receiver: sessionId })
          if (res.session_key) {
            this.nowSessionkey = res.session_key
          }
        }
        if (this.nowSessionkey) {
          this.saveSessionkey(false)
          this.ws.send(JSON.stringify({ event: 'message.read', data: { session_key: this.nowSessionkey } }))
        }
        this.currentName = sessionData.uname
        this.currentstatus = sessionData.status
        this.isDisabled = sessionData.audit == 0
        this.currentSessionId = sessionId
        this.currentGroupId = groupId

        this.$nextTick(() => this.scrollToBottom())
      } catch (error) {
        const errMsg = error.msg || error.message || '获取会话信息失败'
        this.$Message.error(errMsg)
      } finally {
        this.isloading = false
      }
    },

    /* ---------- 获取聊天记录 ---------- */
    async saveSessionkey(isLoadMore = false) {
      if (this.loadingMore || (!isLoadMore && !this.hasMoreData)) return;

      this.loadingMore = true;
      const { havemsg } = await import("@/server/chat")
      try {
        if (!this.nowSessionkey) return
        await havemsg({ page: this.page, page_size: this.page_size, session_key: this.nowSessionkey }).then(res => {
          const list = res.list
          this.messageTotal = res.total
          if (list && list.length > 0) {
            if (isLoadMore) {
              // 加载更多时，将新数据添加到前面（因为历史消息是更早的）
              this.currentMessages = [...list.reverse(), ...this.currentMessages];
            } else {
              // 首次加载，直接设置数据（已经反转过了）
              this.currentMessages = list.reverse();
            }

            // 判断是否还有更多数据
            if (list.length < this.page_size) {
              this.hasMoreData = false;
            } else {
              this.hasMoreData = true;
              this.page++;
            }

            if (!isLoadMore) {
              this.$nextTick(() => this.scrollToBottom())
            } else {
              // 加载更多后，保持滚动位置
              this.$nextTick(() => {
                this.keepScrollPosition();
              });
            }
          } else {
            this.hasMoreData = false;
          }
          if (this.isFirstPage) {
            this.isFirstPage = false;
          }
          this.isloading = false

        })
      } catch (error) {
        this.$Message.error('加载消息失败');
      } finally {
        this.loadingMore = false;
      }

    },

    /* ---------- 图片加载完成回调：触发平滑滚动 ---------- */
    handleImageLoad() {
      // 只在当前最新消息是图片时才滚动，避免历史图片加载打乱浏览位置
      const lastMsg = this.currentMessages[this.currentMessages.length - 1]
      if (lastMsg && lastMsg.message_type === 'image') {
        // this.scrollToBottom(true)
      }
    },
    /* ---------- 消息处理 ---------- */
    handleReceive(data) {
      let message;
      try {
        message = JSON.parse(data)
      } catch (err) {
        console.error('消息解析失败', data)
        return
      }
      switch (message.event) {
        case 'message.send.ok':
          // 发送消息，追加到当前聊天列表
          const msgsendData = message.data.message
          this.currentMessages.push(msgsendData)
          this.updateSessionUnreadAndTop(msgsendData, msgsendData.session_key, msgsendData.content, msgsendData.message_type, 'message.send.ok', msgsendData.receiver.id)
          if (msgsendData.message_type == 'image') {
            setTimeout(() => {
              this.$nextTick(() => this.scrollToBottom())
            }, 100)
          } else {
            this.$nextTick(() => this.scrollToBottom())
          }
          break
        case 'message.send.fail':
          this.$message.error('消息发送失败')
          break
        case 'message.new': {
          //收到新消息
          const msgData = message.data
          // 当前打开的会话，直接追加消息
          if (msgData.session_key === this.nowSessionkey) {
            this.currentMessages.push(msgData)
            this.updateSessionUnreadAndTop(msgData, msgData.session_key, msgData.content, msgData.message_type, 'message.new', '')
            this.$nextTick(() => this.scrollToBottom())
          } else {
            // 其它会话收到消息：置顶会话 + 增加未读
            this.updateSessionUnreadAndTop(msgData, msgData.session_key, msgData.content, msgData.message_type, '', msgData.sender.id)
          }
          break
        }
        case 'message.new.self': {
          const msgsendData = message.data
          // 自己发送的消息，更新已读状态
          this.updateSessionUnreadAndTop(msgsendData, msgsendData.session_key, msgsendData.content, msgsendData.last_message_content, 'message.send.ok', msgsendData.receiver.id)
          this.$nextTick(() => this.scrollToBottom())
          break
        }

        case 'user.online': {
          //用户上线
          const targetId = message.data.user_id;
          this.updateUserStatus(targetId, 'online')
          this.currentstatus = 'online'
          this.isDisabled = false
          break
        }

        case 'user.offline': {
          //用户下线
          const targetId = message.data.user_id;
          this.updateUserStatus(targetId, 'offline')
          this.currentstatus = 'offline'
          break
        }

        case 'message.read.ok':
          //消息已读
          const groupId = message.data.message.user_group_id
          const user_id = message.data.message.user_id
          this.clearSessionUnread(groupId, user_id)
          break
      }
    },

    /* 根据session_key找到会话、未读+1、置顶、更新最新消息预览*/
    updateSessionUnreadAndTop(msgData, sessionKey, content, lastMsgText, type, sessionTd) {
      for (const group of this.sessionList) {
        let sessionIndex = ''
        if (sessionTd) {
          sessionIndex = group.children.findIndex(item => item.id === sessionTd)
        } else {
          sessionIndex = group.children.findIndex(item => item.session_key === sessionKey)
        }

        if (sessionIndex === -1) continue
        const session = group.children[sessionIndex]

        switch (lastMsgText) {
          case 'text':
            session.last_message_content = content
            break
          case 'image':
            session.last_message_content = '[图片]'
            break
          case 'file':
            session.last_message_content = '[文件]'
            break
          default:
            session.last_message_content = msgData.last_message_content
            break
        }
        session.last_message_at_desc = msgData.send_at
        if (!type) {
          // 会话置顶
          session.unread_count += 1

        }
        this.updateUserStatus(session.id, session.status, 1)
        break
      }
      // 重新计算总未读
      this.calcTotalUnread()
    },

    /* 更新用户在线/离线状态 */
    updateUserStatus(userId, status, type) {
      for (const group of this.sessionList) {
        const idx = group.children.findIndex(c => c.id === userId)
        if (idx === -1) continue
      
        const arr = [...group.children]
        const item = { ...arr[idx], status }
        arr.splice(idx, 1)
      
        // 统一边界：第一个"非在线"用户的下标，全部在线则为 arr.length
        const firstNotOnline = arr.findIndex(c => c.status !== 'online')
        const boundary = firstNotOnline === -1 ? arr.length : firstNotOnline
      
        let pos
        if (status === 'online' && type) {
          // 上线且 type=true：插到在线区最前面
          const firstOnline = arr.findIndex(c => c.status === 'online')
          pos = firstOnline === -1 ? boundary : firstOnline
        } else {
          // 上线 type=false：所有在线用户之后
          // 离线：离线区最前面 —— 两者都是 boundary
          pos = boundary
        }
      
        arr.splice(pos, 0, item)
        group.children = arr
        break
      }
    },
    /* 当前会话标记已读，清空红点 */
    clearSessionUnread(groupId, user_id) {
      if (!Array.isArray(this.sessionList)) return
      if (groupId) {
        const group = this.sessionList.find(g => g.id === groupId)
        if (!group) return
        const session = group.children.find(s => s.id === user_id)
        if (session && session.unread_count) {
          session.unread_count = 0
          this.calcTotalUnread()
        }
      } else {
        const group = this.sessionList.find(g => g.id === this.currentGroupId)
        if (!group) return
        const session = group.children.find(s => s.id === this.currentSessionId)
        if (session && session.unread_count) {
          session.unread_count = 0
          this.calcTotalUnread()
        }
      }
    },

    /* 统一计算全部未读总和（替换原来零散累加totalUnread，保证数值准确）*/
    calcTotalUnread() {
      let total = 0
      this.sessionList.forEach(group => {
        let groupUnread = 0
        group.children.forEach(session => {
          const num = Number(session.unread_count || 0)
          groupUnread += num
          total += num
        })
        group.unread_count = groupUnread
      })
      this.totalUnread = this.verify_connection ? total : 0
      this.$store.commit('SET_CHAT_UNREAD', this.totalUnread)
    },

    sendWs(data) {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(data))
      } else {
        this.$message.warning('连接已断开，正在重连...')
        this.connectWs()
      }
    },

    /* ---------- 发送消息 ---------- */
    handleKeydown(e) {
      if ((e.ctrlKey || e.metaKey || e.shiftKey) && e.key === 'Enter') {
        return;
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        this.sendText();
      }
    },
    /* ---------- 发送消息：先发图片，再发文字 ---------- */
    async sendText() {
      const rawText = String(this.inputText || '').trim()

      // 没有任何内容可发
      if (!this.pendingImages.length && !rawText) {
        return this.$message.info('不能发送空白消息')
      }

      // 1. 先发送所有待发送的图片（按顺序一张一张发）
      if (this.pendingImages.length > 0) {
        const imagesToSend = [...this.pendingImages]
        this.pendingImages = [] // 立即清空，防止重复点击

        for (const img of imagesToSend) {
          try {
            await this.uploadFile(img.file, 'image')
          } catch (err) {
            console.error('图片发送失败', err)
          } finally {
            URL.revokeObjectURL(img.previewUrl)
          }
        }
      }

      // 2. 图片发完后，再发输入框里的文字
      if (rawText) {
        this.sendWs({
          event: 'message.send',
          data: {
            session_key: this.nowSessionkey,
            content: rawText,
            message_type: 'text'
          }
        })
        this.inputText = ''
      }
    },
    clearText() {
      this.inputText = ''
    },

    /* ---------- 粘贴图片（只拦截图片，文字正常粘贴） ---------- */
    handlePaste(e) {
      if (!e.clipboardData) return

      // 优先处理截图（clipboardData.items）
      if (e.clipboardData.items) {
        for (let i = 0; i < e.clipboardData.items.length; i++) {
          const item = e.clipboardData.items[i]
          if (item.type.indexOf('image') !== -1) {
            const file = item.getAsFile()
            if (file) {
              e.preventDefault()          // 阻止图片二进制字符插入输入框
              this.addPendingImage(file)
            }
            return
          }
        }
      }

      // 处理从文件夹直接复制的图片文件
      if (e.clipboardData.files && e.clipboardData.files.length > 0) {
        for (let i = 0; i < e.clipboardData.files.length; i++) {
          const file = e.clipboardData.files[i]
          if (file.type.indexOf('image') !== -1) {
            e.preventDefault()
            this.addPendingImage(file)
            return
          }
        }
      }
    },

    /* 将图片加入待发送队列 */
    addPendingImage(file) {
      const MAX_SIZE = 50 * 1024 * 1024
      if (file.size >= MAX_SIZE) {
        this.$message.error('单张图片不能超过 50M')
        return
      }
      const previewUrl = URL.createObjectURL(file)
      this.pendingImages.push({
        file,
        previewUrl,
        id: Date.now() + Math.random()
      })
    },

    /* 移除某张待发送图片 */
    removePendingImage(index) {
      URL.revokeObjectURL(this.pendingImages[index].previewUrl)
      this.pendingImages.splice(index, 1)
    },
    /* ---------- 文件上传 ---------- */
    handleImageUpload({ file }) { this.uploadFile(file, 'image') },
    handleFileUpload({ file }) { this.uploadFile(file, 'file') },
    async uploadFile(file, type) {
      const MAX_SIZE = 50 * 1024 * 1024
      if (file.size >= MAX_SIZE) {
        this.$message.error("上传不能超过50M")
        return
      }
      const t = /^image\//.test(file.type)
      if(type == 'file'){
        if(t){
          this.$message.error("图片资源请更换上传方式")
          return
        }
      }else{
        if(!t){
          this.$message.error("文件资源请更换上传方式")
          return
        }
      }

      
      try {
        // 直接传入原生 File 对象，不要FileReader！
        const res = await $http.post(Tacitly.Base_Port + "upload/file")
          .set('Authorization', localStorage.getItem("t"))
          .attach('file', file)

        if (res.body.code == "0000") {
          const data = res.body.data
          // ===== 在这里发websocket消息 =====
          this.sendWs({
            event: 'message.send',
            data: {
              session_key: this.nowSessionkey,
              message_type: type,
              content: data.url,
              file_name: data.origin_name,
              file_id: data.id
            }
          })
        } else {
          this.$message.error({ content: res.body.msg, key: 'updatable' })
        }
      } catch (err) {
        this.$message.error('文件上传异常')
      }
    },
    getOssUrl(url) {
      // 已经是完整 URL，直接返回
      if (/^https?:\/\//i.test(url)) {
        return url
      }
      // 不是完整 URL，补 OSS 域名
      return 'https://oss.xyajglxt.com/' + url.replace(/^\/+/, '')
    },
    previewImage(currentUrl) {
      currentUrl = this.getOssUrl(currentUrl)
      // 所有聊天图片的 URL 数组
      const images = this.imgList.map(item => this.getOssUrl(item.url))
      // 找到当前点击的图片索引，预览时直接定位到这张
      const currentIndex = images.indexOf(currentUrl)
      this.$viewerApi({
        images: images,
        options: {
          initialViewIndex: currentIndex > -1 ? currentIndex : 0,
          toolbar: true,       // 显示工具栏（放大、缩小、旋转、下载等）
          navbar: true,        // 底部缩略图导航条
          title: true,         // 显示图片标题
          tooltip: true,       // 缩放比例提示
          movable: true,       // 可拖动
          zoomable: true,      // 可缩放
          rotatable: true,     // 可旋转
          transition: true,    // 切换动画
          fullscreen: true,    // 全屏按钮
          keyboard: true,      // 键盘左右键切换
          backdrop: true,      // 遮罩层点击关闭
          loading: true
        }
      })
    },
    downloadFile(msg) {
      if (!msg.content || msg.content === '#') {
        this.$message.info('文件暂无可下载链接：' + (msg.fileName || ''))
        return
      }
      if (msg.message_type == 'document' && this.Filetype(msg.content) == 2) {
        msg.content = this.getOssUrl(msg.content)
      }
      if (this.Filetype(msg.content) == 4) {
        onlineUrlToken(//只读文件
          {
            object: msg.content,
            type: "preview"
          }
        ).then(res => {
          this.info = {
            type: 4,
            Original_url: msg.content,
            url: res.weboffice_url,
            title: msg.file.file_name,
            access_token: res.access_token,
            refresh_token: res.refresh_token,
            access_token_expired_at: res.access_token_expired_at,
            refresh_token_expired_at: res.refresh_token_expired_at,
            message_type: msg.message_type
          }
          this.$refs.FileSee.visible = true
        })
      } else if (this.Filetype(msg.content) == 7) {
        const url = this.downFile(msg)
        fetch(url)
          .then(res => res.blob())
          .then(blob => {
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = msg.file.file_name
            link.click()
            URL.revokeObjectURL(link.href)
          })
      } else {
        this.info = {
          type: this.Filetype(msg.content),
          url: msg.content,
          title: msg.file.file_name || msg.file_name,
        }
        this.$refs.FileSee.visible = true
      }
    },
    downFile(i) {
      const baseUrl = Tacitly.Base_Port;
      return `${baseUrl}common/download?url=${encodeURIComponent(i.content)}&filename=${encodeURIComponent(i.file.file_name)}`
    },
    formatSize(bytes) {
      if (!bytes) return '0 B'
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
      return (bytes / 1024 / 1024).toFixed(1) + ' MB'
    },
    /*  格式化文件显示名称 */
    formatFileShowName,
    /* ---------- 刷新聊天记录 ---------- */
    loadHistory() {
      this.isloading = true
      this.page = 1
      this.loadingMore = false
      this.hasMoreData = true
      this.saveSessionkey(false)
    },
    handleMessageScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      this.scrollPosition = scrollTop;

      if (scrollTop === 0 && this.hasMoreData && !this.loadingMore && !this.isFirstPage) {
        this.oldScrollHeight = scrollHeight;
        this.saveSessionkey(true);
      }
    },
    // 加载更多后保持滚动位置
    keepScrollPosition() {
      const container = this.$refs.msgList;

      if (container) {
        const newScrollHeight = container.scrollHeight;
        container.scrollTop = this.scrollPosition + (newScrollHeight - this.oldScrollHeight);
      }
    },
    /* ---------- 划到 最底部 ---------- */
    scrollToBottom() {
      const el = this.$refs.msgList
      if (el) {
        setTimeout(() => {
          el.scrollTop = el.scrollHeight
        },500)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* 隐藏滚动条 */
.chat-sidebar,
.message-list,
.group-children {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.chat-sidebar::-webkit-scrollbar,
.message-list::-webkit-scrollbar,
.group-children::-webkit-scrollbar {
  display: none;
}

/* ---------- 悬浮按钮 ---------- */
.float-btn {
  position: fixed;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  z-index: 999;
  cursor: grab;
  user-select: none;
  touch-action: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.float-btn:active {
  cursor: grabbing;
}

.float-btn.dragging {
  transition: none;
}

/* SVG图标：硬编码24px，不受字体、行高影响 */
.float-btn-icon {
  width: 24px !important;
  height: 24px !important;
  color: #fff;
  flex-shrink: 0;
}

/* ---------- 聊天窗口 ---------- */
.chat-window {
  position: fixed;
  z-index: 1005;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 400px;
  min-height: 320px;
}

.chat-scale-enter-active,
.chat-scale-leave-active {
  transition: all 0.25s cubic-bezier(0.22, 1, 0.36, 1);
}

.chat-scale-enter,
.chat-scale-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(20px);
}

.load-more {
  text-align: center;
  padding: 15px 0;
  color: #999;
  font-size: 12px;
  background-color: #ffffff;
  position: sticky;
  top: -15px;
  z-index: 10;
}

/* 标题栏 */
.chat-header {
  height: 48px;
  background: linear-gradient(90deg, #2d6fc4, #4facfe);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  cursor: grab;
  user-select: none;
  touch-action: none;
  flex-shrink: 0;
}

.chat-header:active {
  cursor: grabbing;
}

.header-title {
  font-size: 15px;
  font-weight: 500;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.action-icon {
  font-size: 14px;
  cursor: pointer;
  opacity: 0.85;
  padding: 4px;
}

.action-icon:hover {
  opacity: 1;
}

/* 主体 */
.chat-body {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* 左侧分组 */
.chat-sidebar {
  width: 240px;
  border-right: 1px solid #f0f0f0;
  overflow-y: auto;
  background: #fafbfc;
  flex-shrink: 0;
}

.session-group {
  border-bottom: 1px solid #f0f0f0;
}

.group-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  background: #ffffff;
  transition: background 0.2s;
  user-select: none;
}

.group-header:hover {
  background: #e8ecf1;
}

.group-arrow {
  font-size: 12px;
  color: #8aa8c8;
  margin-right: 8px;
  transition: transform 0.2s;
}

.group-name {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #1a3a6a;
}

.group-badge {
  margin-left: 4px;
}

.warning-tip {
  width: 100%;
  height: 40px;
  font-size: 14px;
  color: #fc382a;
  text-align: center;
  background-color: #f7d6d6;
  line-height: 40px;
}

/* 子会话 */
.group-children {
  overflow: hidden;
}

.session-item {
  display: flex;
  // align-items: center;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: 1px solid #f5f5f5;
  position: relative;
}

.session-badge {
  position: absolute;
  top: 4px;
  left: 30px;

  :deep(.ant-badge-count) {
    min-width: 16px;
    /* 最小宽度，单数字时保持圆形 */
    height: 16px;
    /* 徽标高度 */
    line-height: 16px;
    /* 文字垂直居中，和高度保持一致 */
    font-size: 10px;
    /* 数字字号 */
    border-radius: 8px;
    /* 圆角，高度的一半就是正圆 */
    padding: 0 4px;
    /* 水平内边距，多位数时自动撑开 */
  }
}

.session-item:hover {
  background: #f0f5fe;
}

.session-item.active {
  background: #e6f0fc;
}

.session-info {
  flex: 1;
  min-width: 0;
}

.session-time {
  font-size: 10px;
  color: #999;
}

.session-name {
  font-size: 13px;
  color: #333;
  font-weight: 500;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

.session-uname {
  color: #2d6fc4;
  font-weight: 600;
}

.greyuname {
  color: #a3a3a3 !important;
  font-weight: 400;
}

.disablename {
  color: #f85b5060 !important;
  font-weight: 400;
}

.session-status {
  padding: 0 4px;
  background-color: #fff;
  color: #0ac903;
  border: 1px solid #0ac903;
  border-radius: 4px;
  font-size: 9px;
  display: inline-flex;
  margin-left: 6px;
}

.grey {
  color: #a3a3a3;
  border: 1px solid #a3a3a3;
}

.disable {
  color: #f85b5060;
  border: 1px solid #f85b5060;
}

.session-preview {
  width: 140px;
  font-size: 11px;
  color: #999;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 展开动画 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.25s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  max-height: 0;
}

.slide-down-enter-to,
.slide-down-leave {
  opacity: 1;
  max-height: 500px;
}

/* 右侧聊天区 */
.chat-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
}

.spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}

.current-card {
  padding: 5px 10px;
  display: flex;
  align-items: center;

  .name {
    margin-left: 10px;
    color: #2d6fc4;
  }
}

/* 消息列表 */
.message-list {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  background: #f8f9fa;
}

.msg-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 16px;
}

.msg-row.self {
  flex-direction: row-reverse;
}

.msg-row.self .msg-content {
  background: #3ace52;
  color: #fff;
}

.msg-bubble {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 70%;
}

.msg-bubble-my {
  align-items: flex-end;
}

.msg-uname {
  color: #2d6fc4;
  font-size: 12px;
  line-height: 2;
}

.msg-time {
  font-size: 12px;
  color: #bbb;
  line-height: 2;
}

.msg-content {
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #333;
  line-height: 1.5;
  word-break: break-all;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  white-space: pre-wrap !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
}

/* 图片 */
.msg-image {
  max-width: 100px;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  // box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.msg-image img {
  width: 100%;
  display: block;
  transition: transform 0.2s;
}

.msg-image:hover img {
  transform: scale(1.02);
}

/* 文件 */
.msg-file {
  width: 190px;
  height: 60px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  padding: 0 12px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s;
  max-width: 220px;
}

.my {
  background: #3ace52;
  color: #fff;
}

.msg-file:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.file-name {
  font-size: 14px;
  color: #333;
}

.file-size {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.file-type-icon {
  width: 30px;
  height: 30px;
}

/* 工具栏 */
.chat-toolbar {
  padding: 6px 16px;
  background: #fff;
  flex-shrink: 0;
  display: flex;
  gap: 16px;
  // justify-content: space-between;
  align-items: center;
  margin-right: 30px;
}

.toolbar {
  display: flex;
  gap: 26px;
  height: 20px;
}

.tool-btn {
  font-size: 18px;
  color: #666;
  cursor: pointer;
  transition: color 0.2s;
}

.tool-btn:hover {
  color: #2d6fc4;
}

/* 待发送图片预览区 */
.pending-images {
  display: flex;
  gap: 8px;
  padding: 8px 16px 0;
  background: #fff;
  flex-wrap: wrap;
  border-top: 1px solid #f0f0f0;
}

.pending-img-item {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
  flex-shrink: 0;
}

.pending-img-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-pending-img {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
  transition: color 0.2s;
}

.remove-pending-img:hover {
  color: #f5222d;
}

/* 输入区 */
.chat-input-area {
  padding: 12px 16px 4px;
  display: flex;
  gap: 10px;
  background: #fff;
  flex-shrink: 0;
}

.send-btn {
  padding: 3px 10px;
  background-color: #cdcece;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.send-ok {
  background-color: #4facfe;
  color: #fff;
}

.clear-btn {
  padding: 3px 10px;
  background-color: #9a9b9b;
  color: #fff;
  border-radius: 4px;
}

/* 缩放手柄 */
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 26px;
  height: 26px;
  cursor: se-resize;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  border-left: 1px solid #2d6fc4;
  border-top: 1px solid #2d6fc4;
  border-top-left-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: -2px -2px 8px rgba(0, 0, 0, 0.08);
  transition: background 0.2s;
}

.resize-handle:hover {
  background: #e6f0fc;
  border-color: #2d6fc4;
}

.msg-document {
  border-radius: 8px;
  width: 168px;
  padding: 12px;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(103, 156, 226, 0.35);
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}

.document_imag {
  width: 144px;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  background-color: #d6f8e780;
  margin: 8px 0;
  border-radius: 4px;
}

.document-pic {
  width: 63px;
  height: 69px;
}

.document_title {
  font-size: 12px;
  color: #60A5FD;
  text-align: left;
  overflow: hidden;
  /* 超出部分隐藏 */
  white-space: nowrap;
  /* 强制不换行 */
  text-overflow: ellipsis;
}

.resize-lines {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  transform: rotate(-45deg);
}

.r-line {
  height: 2px;
  background: #2d6fc4;
  border-radius: 1px;
}

.r-line:nth-child(1) {
  width: 16px;
}

.r-line:nth-child(2) {
  width: 10px;
}

.r-line:nth-child(3) {
  width: 4px;
}
</style>